module.exports = __webpack_public_path__ + "img/rentals.781c041d.svg";